<template>
  <div class="forget-password">
    <headerBack></headerBack>
    <div class="title">忘记登录密码</div>
    <div class="content">
      <div class="item phone">
        <div class="input-box">
          <label>账号</label>
          <input
            v-model="phone"
            type="text"
            placeholder="请输入账号"
            maxlength="11"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
          />
        </div>
      </div>
      <div class="item code">
        <div class="input-box">
          <label>验证码</label>
          <input
            v-model="sendCode"
            type="text"
            placeholder="请输入验证码"
            maxlength="6"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
          />
        </div>
        <span
          class="code-btn"
          @click="getCode"
          :class="content == '发送验证码' ? '' : 'active'"
          >{{ content }}</span
        >
      </div>
      <div class="item password">
        <div class="input-box">
          <label>新密码</label>
          <input
            v-model="password"
            :type="passwordType"
            placeholder="6-16位数字、字母"
            minlength="6"
            maxlength="16"
          />
        </div>
        <span
          class="eye-btn iconfont iconkejian"
          @click="openEye"
          :class="passwordType == 'password' ? '' : 'active'"
        ></span>
      </div>
      <div class="btn-box">
        <loading-btn btnClass="btn" v-preventReClick @click="handleSubmit">保存新密码</loading-btn>
      </div>
      <div class="row">
        <span></span>
        <span @click="showTip">收不到验证码？</span>
      </div>
    </div>
  </div>
</template>

<script>
import headerBack from "@/components/common/headerBack.vue";
import loadingBtn from "@/components/common/loadingBtn";
import validationMixin from "@/mixins/validationMixin";
import popupConfirm from "@/components/popupcom/popupConfirm.vue";
import commonApi from "@/api/commonApi";
import userApi from "@/api/userApi";
import { AESEncrypted } from "@/libs/util";

export default {
  data() {
    return {
      content: "发送验证码", // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      canClick: true, //添加canClick
      active: true,
      phone: "",
      sendCode: "",
      password: "",
      passwordType: "password", // 密码状态切换
      userStatus: 0, // 后端状态：0 未注册 / 1 正常 / 2 已禁用（原先未声明，赋值不具响应性）
    };
  },
  mixins: [validationMixin],
  mounted() {
    this.phone = window.localStorage.getItem("loginPhone") || "";
  },
  components: {
    headerBack,
    loadingBtn,
    popupConfirm
  },
  methods: {
    openEye() {
      if (this.passwordType === "text") {
        this.passwordType = "password";
      } else {
        this.passwordType = "text";
      }
    },
    getCode() {
      let validations = [
        {
          value: this.phone,
          method: "required",
          message: "请输入账号",
        },
        {
          value: this.phone,
          method: "rangelength",
          param: [8, 11],
          message: "请输入正确的账号",
        },
      ];

      if (this.check(validations)) {
        // 获得手机验证码
        // 获得手机验证码之前先判定用户是否注册
        this.checkUser(() => {
          this.countDown();
        });
      }
    },
    // 判断用户是否注册
    checkUser(callBack) {
      // 先判断用户状态
      userApi
        .checkUserStatus({
          phone: this.phone,
        })
        .then((res) => {
          this.userStatus = res.status;
          // 2026-10-22：status 三分——0 未注册 / 1 正常 / 2 已禁用。
          // 被禁用的账号不能再提示「未注册」，否则用户会反复核对号码。
          if (this.userStatus === 1) {
            // 找回密码
            callBack();
          } else if (this.userStatus === 2) {
            this.$toast("该账号已被禁用，请联系管理员。");
          } else {
            this.$toast("该账号未注册，请仔细核对账号或联系管理员。");
          }
        });
    },
    // 倒计时
    countDown() {
      let validations = [
        {
          value: this.phone,
          method: "required",
          message: "请输入账号",
        },
        {
          value: this.phone,
          method: "rangelength",
          param: [8, 11],
          message: "请输入正确的账号",
        },
      ];

      if (this.check(validations)) {
        if (!this.canClick) return;
        this.canClick = false;

        // 发送短信验证码
        let data = {
          phone: this.phone,
          sms_type: 6, // 1-注册，2-设置交易密码，3-绑定手机号码，4-更换绑定手机号, 5-登录, 6-找回登录密码
        };
        commonApi.sendSmscode(data).then((res) => {
          console.log(res);
        });

        this.content = this.totalTime + "s后重新发送";
        let clock = window.setInterval(() => {
          this.totalTime--;
          this.content = this.totalTime + "s后重新发送";
          if (this.totalTime < 1) {
            //当倒计时小于1时清除定时器
            window.clearInterval(clock);
            this.content = "发送验证码";
            this.totalTime = 60;
            this.canClick = true; //这里重新开启
          }
        }, 1000);
      }
    },
    handleSubmit() {
      let validations = [
        {
          value: this.phone,
          method: "required",
          message: "请输入账号",
        },
        {
          value: this.phone,
          method: "rangelength",
          param: [8, 11],
          message: "请输入正确的账号",
        },
        {
          value: this.sendCode,
          method: "required",
          message: "请输入验证码",
        },
        {
          value: this.sendCode,
          method: "rangelength",
          param: [6, 6],
          message: "验证码输入错误",
        },
        {
          value: this.password,
          method: "required",
          message: "请输入密码（6-16位数字、字母）",
        },
        {
          value: this.password,
          method: "rangelength",
          param: [6, 16],
          message: "密码长度错误（6-16位数字、字母）",
        },
      ];

      if (this.check(validations)) {
        if (!/^[a-z0-9]{6,16}$/.test(this.password)) {
          this.$toast("密码格式错误（6-16位数字、字母）");
          return;
        }
        // 将密码明文进行AES加密
        const ciphertext = AESEncrypted(this.password);
        const params = {
          password: ciphertext,
          phone: this.phone,
          send_code: this.sendCode,
        };
        userApi.resetLoginPassword(params).then((res) => {
          console.log(res);
          this.$toast("重置登录密码成功!请重新登录...");
          setTimeout(() => {
            this.$router.push({
              name: "Login",
            });
          }, 2000);
        });
      }
    },
    showTip() {
      this.$dialog.alert({
        title: "收不到验证码？",
        message:
          "1.请检查是否输入正确手机号或邮箱\n2.检查手机号是否停机、空号、暂停服务、关机、不在服务区\n3.请使用其他账号登录\n4.手机号在黑名单(平台或运营商)",
        messageAlign: "left",
        showConfirmButton: true,
        confirmButtonText: "知道了",
        closeOnClickOverlay: true,
        confirmButtonColor: "#8a3e2f",
      });
    },
    confirmEvent() {
      this.$router.push({
        name: "bindInviteCode",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.forget-password {
  padding: 34.133vw 8vw 0 8vw;

  .title {
    font-size: 30px;
    color: #333333;
  }
  .content {
    margin-top: 50px;
    width: 100%;

    .item {
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e4e4e4;
      font-size: 14px;

      label {
        width: 45px;
        display: inline-block;
        font-size: 14px;
        color: #333333;
        margin-right: 20px;
      }

      .code-btn {
        position: absolute;
        right: 30px;
        font-size: 14px;
        color: #8a3e2f;

        &.active {
          color: #999999;
        }
      }

      .eye-btn {
        font-size: 12px;
        color: #999999;
        display: block;
        padding: 10px;

        &.active {
          color: #8a3e2f;
        }
      }
    }

    .row {
      padding: 15px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 12px;
        color: #666666;
      }
    }

    .btn-box {
      margin-top: 97px;
      .btn {
        width: 100%;
        height: 44px;
        text-align: center;
        line-height: 44px;
        background: #8a3e2f;
        font-size: 17px;
        color: #ffffff;
      }
    }
  }
}
</style>
